import { DispatchScope, Stop } from "@api/graphql/generated/generated-types";
import { RouteViewMode } from "@src/common/components/ChangeDriverRouteView/ChangeDriverRouteView";

export function getUniqueStopDates(routeDetails: any[]): any[] | undefined {
  const uniqueStopDates = Array.from(
    new Set(
      routeDetails
        .map((routeDetail) => {
          if (routeDetail.__typename === "Task" && routeDetail.stop.effectiveStopDate) {
            return routeDetail.stop.effectiveStopDate;
          } else if (
            routeDetail.__typename === "Stop" &&
            routeDetail.effectiveStopDate
          ) {
            return routeDetail.effectiveStopDate;
          }
          return undefined;
        })
        .filter(Boolean)
    )
  ).sort();

  return uniqueStopDates.length > 0 ? uniqueStopDates : undefined;
}

export const getStopIds = (routeDetails: Stop[] | undefined) => {
  if (!routeDetails) {
    return [];
  }
  return routeDetails.map((routeDetail) => {
    return routeDetail.id;
  });
};

/**
 * Dispatching an order that is in an assignment group sends the whole group. Every other case is
 * single-order: an ungrouped order (or a row without the group field) skips the group lookups, and
 * changing a driver or a route moves one order of a group on its own.
 */
export function getDispatchScope(
  routeViewMode: RouteViewMode,
  assignmentGroupId: string | null | undefined,
): DispatchScope {
  return routeViewMode === RouteViewMode.Dispatch && Boolean(assignmentGroupId)
    ? DispatchScope.AssignmentGroup
    : DispatchScope.SingleOrder;
}

/** The group's days from cube when it returned any, otherwise the order's own stop days. */
export function pickStopDatesForDispatch(
  groupStopDates: string[] | undefined,
  ownStopDates: string[] | undefined,
): string[] | undefined {
  return groupStopDates && groupStopDates.length > 0 ? groupStopDates : ownStopDates;
}
